import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import LanguageSelectStore from '@src/business-components/common-language-select/store';

// const styles = require('./index.less');
const styles = require('./rem.less');

/**
 * 语言选择器
 * @param store {LanguageSelectStore}
 * @param buttonDisplay
 * @returns {JSX.Element}
 * @constructor
 * @example
 * footer使用: <LanguageSelect buttonDisplay={'footer'} />
 * header使用: <LanguageSelect buttonDisplay={'nav'} />
 */
const LanguageSelect = ({ store, buttonDisplay }) => {
  store.use();

  const styleName = {
    nav: styles.language_nav_container,
    footer: styles.language_footer_container
  };
  const renderBtn = () => {
    if (buttonDisplay === 'nav') {
      return (
        <div className={cx(styles.btn_display_nav)} onMouseEnter={store.onLanguageBtnMouseEnter} onMouseLeave={store.onLanguageBtnMouseLeave}>
          <div className={cx(styles.btn_background_nav, store.isOpen && styles.innerExpanded_nav)} />
          <div className={styles.pc_icon_language_nav} />
        </div>
      );
    } else if (buttonDisplay === 'footer') {
      return (
        <div
          className={cx(styles.btn_display_footer, store.isOpen && styles.innerExpanded_footer)}
          onMouseEnter={store.onLanguageBtnMouseEnter}
          onMouseLeave={store.onLanguageBtnMouseLeave}
        >
          <div className={styles.selectedText}>
            <div className={styles.pc_icon_language_footer} />
            <div className={styles.language_switch_text}>{store.currentLanguageObject?.language}</div>
            <div className={styles.pc_icon_flyout} />
          </div>
        </div>
      );
    }
  };
  const renderExpand = () => {
    if (buttonDisplay === 'nav') {
      return (
        <div
          onWheel={e => e.stopPropagation()}
          data-name="languageExpand"
          data-open={store.isOpen}
          className={cx(styles.expand_display_nav, store.isOpen && styles.show)}
          onMouseEnter={store.onLanguageBtnMouseEnter}
          onMouseLeave={store.onLanguageBtnMouseLeave}
        >
          <div className={styles.expand_display_nav1}>
            {store.languageList.map((item, index) => {
              return (
                <div
                  key={index}
                  className={cx(styles.language_tag_nav, store.currentLanguageObject?.language === item.language && styles.nav_language_selected)}
                  onClick={() => store.onLanguageSelected(item)}
                >
                  <div className={styles.language_text_nav}>{item.language}</div>
                  <div className={styles.language_tick1} />
                </div>
              );
            })}
          </div>
        </div>
      );
    } else if (buttonDisplay === 'footer') {
      return (
        <div
          onWheel={e => e.stopPropagation()}
          data-name="languageExpand"
          data-open={store.isOpen}
          className={cx(styles.expand_display_footer, store.isOpen && styles.show)}
          onMouseEnter={store.onLanguageBtnMouseEnter}
          onMouseLeave={store.onLanguageBtnMouseLeave}
        >
          <div className={styles.expand_display_nav2}>
            {store.languageList.map((item, index) => {
              return (
                <div
                  key={index}
                  className={cx(styles.language_tag_bottom, store.currentLanguageObject?.language === item.language && styles.languageSelected)}
                  onClick={() => store.onLanguageSelected(item.languageKey)}
                >
                  <div className={styles.language_text}>{item.language}</div>
                  <div className={styles.language_tick2} />
                </div>
              );
            })}
          </div>
        </div>
      );
    }
  };
  return (
    <div className={styleName[buttonDisplay]} id={'languageContainer_nav'}>
      {buttonDisplay === 'nav' && (
        <div className={styles.expand_display_box} onMouseEnter={store.onLanguageBtnMouseEnter} onMouseLeave={store.onLanguageBtnMouseLeave} />
      )}
      {renderBtn()}
      {renderExpand()}
    </div>
  );
};

export default wrapStore(LanguageSelect, LanguageSelectStore);
